<div style="margin-top:0px;">

  <div fxLayoutAlign.gt-sm="end center center" fxLayoutAlign.lt-md="center stretch" fxFlex.lt-md="100">
    <button ngStyle.lt-md="width:100%;"
            style="background: var(--primary); color:white; font-weight: normal; vertical-align: middle;"
            mat-flat-button [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger">
      Ενέργειες
      &nbsp;
      <mat-icon style="vertical-align: middle; color:white;">
        {{menuTrigger.menuOpen ? 'expand_less' : 'expand_more'}}
      </mat-icon>
    </button>

    <mat-menu #menu="matMenu">
      <mat-list>
        <mat-list-item class="menuList" >
          <button mat-menu-item (click)="exportToExcel()">
            <mat-icon class="icon">description</mat-icon> &nbsp;Εξαγωγή σε xlsx
          </button>
        </mat-list-item>
        <mat-list-item class="menuList" >
          <button mat-menu-item (click)="exportToPDF()">
            <mat-icon class="icon">picture_as_pdf</mat-icon> &nbsp;Εξαγωγή σε pdf
          </button>
        </mat-list-item>
        <mat-list-item class="menuList" >
          <button mat-menu-item disabled="true" (click)="sendExcelToEmail()">
            <mat-icon class="icon">clear</mat-icon>&nbsp;Προσθήκη xlsx σε email
          </button>
        </mat-list-item>
        <mat-list-item class="menuList" >
          <button mat-menu-item (click)="sendPDFToEmail()">
            <mat-icon class="icon">email</mat-icon>&nbsp;Προσθήκη pdf σε email
          </button>
        </mat-list-item>
      </mat-list>
    </mat-menu>
  </div>


  <div #tableContainer>
    <table mat-table [dataSource]="data" style="width:100%;">

      <ng-container matColumnDef="parentFirstName">
        <th mat-header-cell *matHeaderCellDef> Όνομα</th>
        <td mat-cell *matCellDef="let element"> {{element.parentFirstName}} </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="parentLastName">
        <th mat-header-cell *matHeaderCellDef> Επώνυμο</th>
        <td mat-cell *matCellDef="let element"> {{element.parentLastName}} </td>
      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef> Email</th>
        <td mat-cell *matCellDef="let element"> {{element.email}} </td>
      </ng-container>

      <ng-container matColumnDef="childName">
        <th mat-header-cell *matHeaderCellDef> Όνομα</th>
        <td mat-cell *matCellDef="let element"> {{element.childName}} </td>
      </ng-container>

      <ng-container matColumnDef="childLastName">
        <th mat-header-cell *matHeaderCellDef> Επώνυμο</th>
        <td mat-cell *matCellDef="let element"> {{element.childLastName}} </td>
      </ng-container>

      <ng-container matColumnDef="childClass">
        <th mat-header-cell *matHeaderCellDef> Τάξη</th>
        <td mat-cell *matCellDef="let element"> {{element.childClass}} </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef> Κατάσταση</th>
        <td mat-cell *matCellDef="let element">
          <div class="statusButton"
               [ngStyle]="{'background-color': commonService.getButtonColor(+element.status)}"
               fxLayoutAlign="center center center">{{+element.status === 1 ? 'Αποδοχή' : +element.status === -1 ? 'Σε Αναμονή' : 'Απόρριψη'}}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="provider">
        <th mat-header-cell *matHeaderCellDef> Πάροχος ειδοποίησης</th>
        <td mat-cell *matCellDef="let element"> {{element.provider}} </td>
      </ng-container>

      <ng-container matColumnDef="consentDate">
        <th mat-header-cell *matHeaderCellDef> Ημ. Συναίνεσης</th>
        <td mat-cell *matCellDef="let element"> {{element.consentDate}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
      <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
    </table>
  </div>
</div>
